import ApiService from '../../../../../services/ApiService'
import Utils from '../../../../../Utils/FormatDate'
import SignatureScreen from '../../../../../components/SignatureScreen.vue'
import moment from 'moment'

export default {
  props: {
    serviceOrder: Object,
  },

  components: {
    SignatureScreen,
  },

  created() {
    this.currentUser = JSON.parse(localStorage.getItem('user'))
    this.institution = JSON.parse(localStorage.getItem('institution'))
    if (this.serviceOrder) {
      this.currentServiceOrder = this.serviceOrder
      this.closeServiceOrderDateTime =
        this.serviceOrder.closeServiceOrderDateTime
      this.disable =
        this.institution.userType == 4 ||
        this.institution.userType == 5 ||
        this.serviceOrder.status == 1
    }
  },

  data: () => ({
    newSchedule: false,
    step: 0,
    selectedTab: 0,
    errorMessage: '',
    menuCloseDate: false,
    loading: false,
    firstValid: false,
    error: false,
    signatureConfirmDialog: false,
    signatureErrorDialog: false,
    closeServiceOrderDateTimeError: false,
    disable: false,
    closeDate: null,
    closeTime: null,
    closeServiceOrderDateTime: null,
    currentUser: {},
    option: 0,
    nextOrders: [],
    currentServiceOrder: {
      id: 0,
      ratingServiceCompleted: null,
      ratingServiceTime: null,
      closeDate: null,
      emailForEvaluation: null,
    },
    newRequestDate: null,
    signature: '',
    closeDateRules: [(v) => !!v || 'Data e hora requerida'],
    emailRules: [(v) => v == null || /.+@.+\..+/.test(v) || 'E-mail inválido'],

    apiService: new ApiService(),
  }),

  computed: {
    title() {
      if (this.step === 1 || (this.step == 2 && this.newSchedule)) {
        return 'Novo agendamento'
      }

      return this.currentServiceOrder.status == 0
        ? this.$t('Fechamento de Ordem de Serviço')
        : this.$t('Ordem de Serviço Fechada')
    },

    descriptionText() {
      if (
        this.serviceOrder.equipment &&
        this.serviceOrder.equipment.standardEquipment
      ) {
        if (
          (this.serviceOrder.serviceOrderType === 6 ||
            this.serviceOrder.serviceOrderType === 'Calibração') &&
          this.serviceOrder.equipment.standardEquipment.calibrationSet
        ) {
          return 'Deseja agendar sua próxima calibração para este equipamento?'
        } else if (
          (this.serviceOrder.serviceOrderType === 2 ||
            this.serviceOrder.serviceOrderType === 'Segurança elétrica') &&
          this.serviceOrder.equipment.standardEquipment.electricalEngineeringSet
        ) {
          return 'Deseja agendar seu próximo Teste de Segurança elétrica para este equipamento?'
        } else if (
          (this.serviceOrder.serviceOrderType === 7 ||
            this.serviceOrder.serviceOrderType === 'Validação/Qualificação') &&
          this.serviceOrder.equipment.standardEquipment
            .validationQualificationSet
        ) {
          return 'Deseja agendar sua próxima Validação/Qualificação para este equipamento?'
        } else if (
          this.serviceOrder.serviceOrderType === 4 ||
          this.serviceOrder.serviceOrderType === 'Rotina de Inspeção'
        ) {
          return 'Deseja agendar sua próxima Rotina de Inspeção para este equipamento?'
        }
      } else {
        if (
          this.serviceOrder.serviceOrderType === 4 ||
          this.serviceOrder.serviceOrderType === 'Rotina de Inspeção'
        ) {
          return 'Deseja agendar sua próxima Rotina de Inspeção para este setor?'
        }
      }

      return ''
    },

    tableTitle() {
      if (
        this.serviceOrder.equipment &&
        this.serviceOrder.equipment.standardEquipment
      ) {
        if (
          (this.serviceOrder.serviceOrderType === 6 ||
            this.serviceOrder.serviceOrderType === 'Calibração') &&
          this.serviceOrder.equipment.standardEquipment.calibrationSet
        ) {
          return 'Próximas calibrações para este equipamento:'
        } else if (
          (this.serviceOrder.serviceOrderType === 2 ||
            this.serviceOrder.serviceOrderType === 'Segurança elétrica') &&
          this.serviceOrder.equipment.standardEquipment.electricalEngineeringSet
        ) {
          return 'Próximos Testes de Segurança elétrica para este equipamento:'
        } else if (
          (this.serviceOrder.serviceOrderType === 7 ||
            this.serviceOrder.serviceOrderType === 'Validação/Qualificação') &&
          this.serviceOrder.equipment.standardEquipment
            .validationQualificationSet
        ) {
          return 'Próximas Validação/Qualificação para este equipamento:'
        }
      }

      return ''
    },

    finalTitle() {
      if (this.newSchedule) {
        return 'Agendamento realizado com sucesso!'
      }
      return 'Fechamento de Ordem de Serviço realizado com sucesso!'
    },

    dateLabel() {
      if (
        this.serviceOrder.equipment &&
        this.serviceOrder.equipment.standardEquipment
      ) {
        if (
          (this.serviceOrder.serviceOrderType === 6 ||
            this.serviceOrder.serviceOrderType === 'Calibração') &&
          this.serviceOrder.equipment.standardEquipment.calibrationSet
        ) {
          return 'Próxima calibração:'
        } else if (
          (this.serviceOrder.serviceOrderType === 2 ||
            this.serviceOrder.serviceOrderType === 'Segurança elétrica') &&
          this.serviceOrder.equipment.standardEquipment.electricalEngineeringSet
        ) {
          return 'Próximo Teste de Segurança Elétrica:'
        } else if (
          (this.serviceOrder.serviceOrderType === 7 ||
            this.serviceOrder.serviceOrderType === 'Validação/Qualificação') &&
          this.serviceOrder.equipment.standardEquipment
            .validationQualificationSet
        ) {
          return 'Próxima Validação/Qualificação:'
        }
      }

      return ''
    },

    buttonText() {
      switch (this.step) {
        case 0:
          return 'Confirmar'
        default:
          return 'Terminar'
      }
    },
  },

  methods: {
    validateDates() {
      const attendDate = this.serviceOrder.dateTimeAttend
      const finalDate = this.closeServiceOrderDateTime
      let valid = true

      if (
        !!attendDate &&
        !!finalDate &&
        moment(attendDate).isAfter(moment(finalDate))
      ) {
        this.$toast.warning(
          'A data de fechamento não pode ser antes da data de atendimento'
        )
        valid = false
      }

      return valid
    },

    close() {
      if (this.step > 0) {
        this.$router.push('/serviceOrders')
      }
      this.$emit('close')
    },

    async next() {
      if (this.step === 0) {
        if (this.$refs.firstForm.validate() && this.validateDates()) {
          if (this.currentServiceOrder.supplierId != null) {
            if (
              this.currentServiceOrder.ratingServiceCompleted == null ||
              this.currentServiceOrder.ratingServiceTime == null
            ) {
              this.$toast.error('Avaliação obrigatória')
              return
            }
          }

          this.signatureConfirmDialog = true
        }
      } else if (this.step === 1) {
        this.scheduleOrder()
      } else {
        this.close()
      }
    },

    scheduleOrder() {
      if (!this.newSchedule) {
        this.step++
        return
      }

      if (this.newRequestDate) {
        this.apiService
          .post('serviceOrder/schedule-new-order', {
            serviceOrderId: this.serviceOrder.id,
            requestDate: moment(this.newRequestDate).format(
              'yyyy-MM-DDTHH:mm:ss'
            ),
          })
          .then(() => {
            this.$toast.success('Agendamento realizado com sucesso!')
            this.step++
          })
      } else {
        this.$toast.error('Insira uma data para o agendamento do novo serviço!')
      }
    },

    formatDateTime(date) {
      return Utils.dateTime(date)
    },

    parseDate(date) {
      if (!date) return null

      const dateTimeSplit = date.split(' ')

      const [day, month, year] = dateTimeSplit[0].split('/')
      const time = dateTimeSplit[1]

      if (time) {
        return `${year}-${month.padStart(2, '0')}-${day.padStart(
          2,
          '0'
        )} ${time}:00`
      }

      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    formatInputDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('T')[0].split('-')
      return `${day}/${month}/${year}`
    },

    async signServiceOrder(data) {
      if (this.option == 0) {
        if (this.currentUser.signatureImage) {
          this.currentServiceOrder.isExecutingSigned = true
          this.currentServiceOrder.executingUserId = this.currentUser.id
          this.submit()
        } else {
          this.signatureConfirmDialog = false
          this.signatureErrorDialog = true
        }
      } else if (this.option == 1) {
        this.currentServiceOrder.isExecutingSigned = true
        this.currentServiceOrder.executingUserId = this.currentUser.id
        this.signature = data
        this.submit()
      } else {
        if (
          this.currentServiceOrder &&
          this.currentServiceOrder.responsibleName
        ) {
          this.apiService
            .get(`byName/${this.currentServiceOrder.responsibleName}`)
            .then((response) => {
              if (response.content && response.content.signatureImage) {
                this.currentServiceOrder.isExecutingSigned = true
                this.currentServiceOrder.executingUserId = response.content.id
                this.submit()
              } else {
                this.signatureConfirmDialog = false
                this.signatureErrorDialog = true
              }
            })
        } else {
          this.$toast.error(
            'Nenhum responsável encontrado na Ordem de Serviço!'
          )
        }
      }
    },

    setNowDate() {
      this.closeServiceOrderDateTime = !this.closeServiceOrderDateTime
        ? new Date()
        : this.closeServiceOrderDateTime
    },

    setNowRequestDate() {
      this.newRequestDate = !this.newRequestDate
        ? new Date()
        : this.newRequestDate
    },

    async getNextOrders() {
      this.apiService
        .get('serviceOrder/new-equipment-orders/' + this.serviceOrder.id)
        .then((response) => {
          this.nextOrders = response.content
        })
    },

    async submit() {
      this.loading = true
      if (!this.serviceOrder.responsibleName) {
        this.$toast.error(
          'Insira o responsável para fechar a ordem de serviço!'
        )

        this.signatureConfirmDialog = false
        this.signatureErrorDialog = false
        this.loading = false
        return
      }

      if (!this.closeServiceOrderDateTime) {
        this.$toast.error('Adicione a data/hora de fechamento')

        this.signatureConfirmDialog = false
        this.signatureErrorDialog = false
        this.loading = false
        return
      }

      const serviceOrder = {
        Id: this.currentServiceOrder.id,
        CloseServiceOrderDateTime: Utils.nowDatetimeFormat(
          this.closeServiceOrderDateTime
        ),
        EmailForEvaluation: this.currentServiceOrder.emailForEvaluation,
        RatingServiceCompleted: this.currentServiceOrder.ratingServiceCompleted,
        RatingServiceTime: this.currentServiceOrder.ratingServiceTime,
        isExecutingSigned: this.currentServiceOrder.isExecutingSigned,
        ExecutingUserId: this.currentServiceOrder.executingUserId,
        validatorName: this.currentServiceOrder.validatorName,
        ExecutingUserName: this.currentServiceOrder.executingUserName,
        SignatureData: this.signature,
      }

      await this.apiService
        .post('serviceOrder/closeServiceOrder', serviceOrder)
        .then(() => {
          if (
            this.serviceOrder.equipment &&
            this.serviceOrder.equipment.standardEquipment
          ) {
            if (
              (this.serviceOrder.serviceOrderType === 6 ||
                this.serviceOrder.serviceOrderType === 'Calibração') &&
              this.serviceOrder.equipment.standardEquipment.calibrationSet
            ) {
              switch (
                this.serviceOrder.equipment.standardEquipment
                  .calibrationSchedulePeriod
              ) {
                case 0:
                  this.newRequestDate = new Date(
                    moment(serviceOrder.CloseServiceOrderDateTime)
                      .add(1, 'M')
                      .format('yyyy-MM-DD 08:00')
                  )
                  break
                case 1:
                  this.newRequestDate = new Date(
                    moment(serviceOrder.CloseServiceOrderDateTime)
                      .add(2, 'M')
                      .format('yyyy-MM-DD 08:00')
                  )
                  break
                case 2:
                  this.newRequestDate = new Date(
                    moment(serviceOrder.CloseServiceOrderDateTime)
                      .add(3, 'M')
                      .format('yyyy-MM-DD 08:00')
                  )
                  break
                case 3:
                  this.newRequestDate = new Date(
                    moment(serviceOrder.CloseServiceOrderDateTime)
                      .add(6, 'M')
                      .format('yyyy-MM-DD 08:00')
                  )
                  break
                case 5:
                  this.newRequestDate = new Date(
                    moment(serviceOrder.CloseServiceOrderDateTime)
                      .add(2, 'y')
                      .format('yyyy-MM-DD 08:00')
                  )
                  break
                default:
                  this.newRequestDate = new Date(
                    moment(serviceOrder.CloseServiceOrderDateTime)
                      .add(1, 'y')
                      .format('yyyy-MM-DD 08:00')
                  )
                  break
              }
              this.step = 1
              this.getNextOrders()
            } else if (
              (this.serviceOrder.serviceOrderType === 2 ||
                this.serviceOrder.serviceOrderType === 'Segurança elétrica') &&
              this.serviceOrder.equipment.standardEquipment
                .electricalEngineeringSet
            ) {
              switch (
                this.serviceOrder.equipment.standardEquipment
                  .electricalEngineeringSchedulePeriod
              ) {
                case 0:
                  this.newRequestDate = new Date(
                    moment(serviceOrder.CloseServiceOrderDateTime)
                      .add(1, 'M')
                      .format('yyyy-MM-DD 08:00')
                  )
                  break
                case 1:
                  this.newRequestDate = new Date(
                    moment(serviceOrder.CloseServiceOrderDateTime)
                      .add(2, 'M')
                      .format('yyyy-MM-DD 08:00')
                  )
                  break
                case 2:
                  this.newRequestDate = new Date(
                    moment(serviceOrder.CloseServiceOrderDateTime)
                      .add(3, 'M')
                      .format('yyyy-MM-DD 08:00')
                  )
                  break
                case 3:
                  this.newRequestDate = new Date(
                    moment(serviceOrder.CloseServiceOrderDateTime)
                      .add(6, 'M')
                      .format('yyyy-MM-DD 08:00')
                  )
                  break
                case 5:
                  this.newRequestDate = new Date(
                    moment(serviceOrder.CloseServiceOrderDateTime)
                      .add(2, 'y')
                      .format('yyyy-MM-DD 08:00')
                  )
                  break
                default:
                  this.newRequestDate = new Date(
                    moment(serviceOrder.CloseServiceOrderDateTime)
                      .add(1, 'y')
                      .format('yyyy-MM-DD 08:00')
                  )
                  break
              }
              this.step = 1
              this.getNextOrders()
            } else if (
              (this.serviceOrder.serviceOrderType === 7 ||
                this.serviceOrder.serviceOrderType ===
                  'Validação/Qualificação') &&
              this.serviceOrder.equipment.standardEquipment
                .validationQualificationSet
            ) {
              switch (
                this.serviceOrder.equipment.standardEquipment
                  .validationSchedulePeriod
              ) {
                case 0:
                  this.newRequestDate = new Date(
                    moment(serviceOrder.CloseServiceOrderDateTime)
                      .add(1, 'M')
                      .format('yyyy-MM-DD 08:00')
                  )
                  break
                case 1:
                  this.newRequestDate = new Date(
                    moment(serviceOrder.CloseServiceOrderDateTime)
                      .add(2, 'M')
                      .format('yyyy-MM-DD 08:00')
                  )
                  break
                case 2:
                  this.newRequestDate = new Date(
                    moment(serviceOrder.CloseServiceOrderDateTime)
                      .add(3, 'M')
                      .format('yyyy-MM-DD 08:00')
                  )
                  break
                case 3:
                  this.newRequestDate = new Date(
                    moment(serviceOrder.CloseServiceOrderDateTime)
                      .add(6, 'M')
                      .format('yyyy-MM-DD 08:00')
                  )
                  break
                case 5:
                  this.newRequestDate = new Date(
                    moment(serviceOrder.CloseServiceOrderDateTime)
                      .add(2, 'y')
                      .format('yyyy-MM-DD 08:00')
                  )
                  break
                default:
                  this.newRequestDate = new Date(
                    moment(serviceOrder.CloseServiceOrderDateTime)
                      .add(1, 'y')
                      .format('yyyy-MM-DD 08:00')
                  )
                  break
              }
              this.step = 1
              this.getNextOrders()
            } else if (
              this.serviceOrder.serviceOrderType === 4 ||
              this.serviceOrder.serviceOrderType === 'Rotina de Inspeção'
            ) {
              this.step = 1
              this.getNextOrders()
            } else {
              this.step = 2
              this.getNextOrders()
            }
          } else if (
            this.serviceOrder.serviceOrderType === 4 ||
            this.serviceOrder.serviceOrderType === 'Rotina de Inspeção'
          ) {
            this.step = 1
            this.getNextOrders()
          } else {
            this.step = 2
          }
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })

      this.signatureConfirmDialog = false
      this.signatureErrorDialog = false
      this.loading = false
    },
  },

  watch: {
    menuCloseDate(value) {
      if (value) {
        this.selectedTab = 0
        if (this.$refs.timer) {
          this.$refs.timer.selectingHour = true
        }
      }
    },
  },
}
